import { render } from "./SidePanel.vue?vue&type=template&id=25905da4&scoped=true"
import script from "./SidePanel.vue?vue&type=script&lang=js"
export * from "./SidePanel.vue?vue&type=script&lang=js"

import "./SidePanel.vue?vue&type=style&index=0&id=25905da4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25905da4"]])

export default __exports__